import { toast } from 'react-toastify';

import http from '../../http/http-common';
import { generatePath } from 'react-router-dom';
import { AxiosError, AxiosRequestConfig } from 'axios';
import { BaseApi } from '../../http/base-api.service';
import { IMetaField } from '../../../types/meta-fields-types';

const apiService = new BaseApi();
const headers: AxiosRequestConfig['headers'] = apiService.getApiVersionHeader();

const DEFAULT_STATE: { metaFields: IMetaField[] | null } = {
  metaFields: null,
};

const createBaseMetaFieldsModel = (url: string) => {
  return {
    state: DEFAULT_STATE,
    reducers: {
      setList(state, payload) {
        return {
          ...state,
          metaFields: payload,
        };
      },
      resetState() {
        return DEFAULT_STATE;
      },
    },
    effects: () => ({
      async getMetaFields(id: string): Promise<IMetaField[]> {
        try {
          const path = generatePath(url, { id });
          const response = await http.get(path, { headers });

          return response.data as IMetaField[];
        } catch (error: unknown) {
          if (error instanceof AxiosError) {
            toast.error(error.response?.data?.message || 'An unexpected error occurred');
          } else if (error instanceof Error) {
            toast.error(error.message);
          } else {
            toast.error('An unexpected error occurred');
          }
          throw error;
        }
      },

      async createMetaField(payload: { id: string; data: { key: string; value: string } }): Promise<IMetaField> {
        try {
          const path = generatePath(url, { id: payload.id });
          const response = await http.post(path, payload.data, { headers });
          toast.success('Meta field created successfully');

          return response.data as IMetaField;
        } catch (error: unknown) {
          if (error instanceof AxiosError) {
            toast.error(error.response?.data?.message || 'An unexpected error occurred');
          } else if (error instanceof Error) {
            toast.error(error.message);
          } else {
            toast.error('An unexpected error occurred');
          }
          throw error;
        }
      },

      async updateListMetaFields({ id, list }: { id: string; list: IMetaField[] }) {
        try {
          const path = generatePath(url, { id });
          await http.patch(path, list, { headers });
          toast.success('Meta fields updated successfully');
        } catch (error: unknown) {
          if (error instanceof AxiosError) {
            toast.error(error.response?.data?.message || 'An unexpected error occurred');
          } else if (error instanceof Error) {
            toast.error(error.message);
          } else {
            toast.error('An unexpected error occurred');
          }
          throw error;
        }
      },

      async deleteMetaField({ id, metaFieldId }: { id: string; metaFieldId: string }) {
        try {
          const path = generatePath(url, { id });
          const pathToDelete = `${path}/${metaFieldId}`;
          await http.delete(pathToDelete, { headers });
          toast.success('Meta field deleted successfully');
        } catch (error: unknown) {
          if (error instanceof AxiosError) {
            toast.error(error.response?.data?.message || 'An unexpected error occurred');
          } else if (error instanceof Error) {
            toast.error(error.message);
          } else {
            toast.error('An unexpected error occurred');
          }
          throw error;
        }
      },
    }),
  };
}

export default createBaseMetaFieldsModel;